module.exports = __webpack_public_path__ + "img/check2-circle.a2e16429.svg";